"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTableItem = void 0;
const react_1 = __importDefault(require("react"));
const crate_1 = require("@tcc/crate");
const emptyTableItem_css_1 = require("./emptyTableItem.css");
const EmptyTableItem = ({ message, icon, content }) => (react_1.default.createElement("div", { className: emptyTableItem_css_1.container, "data-test-id": "fds-table-empty-table-item" },
    react_1.default.createElement(crate_1.Icon, { className: emptyTableItem_css_1.iconElem, glyph: icon !== null && icon !== void 0 ? icon : crate_1.Icon.set.WARNING_CIRCLE, testId: "fds-table-empty-table-item-icon" }),
    react_1.default.createElement("div", { "data-test-id": "fds-table-empty-table-item-message" }, message),
    content));
exports.EmptyTableItem = EmptyTableItem;
